import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  dialogTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: theme.spacing(1),
    gap: theme.spacing(1),
  },
  multiSelect: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
